import { supabase } from '@/integrations/supabase/client';

export async function getUserRole(userId: string): Promise<string | null> {
  try {
    const { data, error } = await supabase
      .from('user_roles')
      .select('role')
      .eq('user_id', userId);
    
    if (error) {
      console.error('Error fetching user role:', error);
      return null;
    }
    
    if (!data || data.length === 0) {
      return null;
    }
    
    // Return the first role (prioritize broker if multiple roles exist)
    const roles = data.map(r => r.role);
    if (roles.includes('broker')) return 'broker';
    if (roles.includes('seller')) return 'seller';
    if (roles.includes('admin')) return 'admin';
    return roles[0];
  } catch (e) {
    console.error('Exception fetching user role:', e);
    return null;
  }
}
